import { store } from '../store'
import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import { InventoryEnum } from '../enums/modules/routes'
import { InventoryRouteValidator } from '@/components/inventory/routeValidator'
import { InventoryExportActions } from '@/enums/modules/inventory'

// Vuex Modules to load
const InventoryModule = () => import(/* webpackChunkName: "Inventory" */ '../store/modules/inventory')

// Components
const Inventory = () =>
  import(/* webpackChunkName: "Inventory" */ '@/components/inventory/Inventory')

const InventoryPlaceholder = () =>
  import(/* webpackChunkName: "Inventory" */ '@/components/inventory/InventoryPlaceholder')

const LotBreakdown = () =>
  import(/* webpackChunkName: "Inventory" */ '@/components/inventory/modals/LotBreakdown')

const LotBreakdownByStatus = () =>
  import(/* webpackChunkName: "Inventory" */ '@/components/inventory/modals/LotBreakdownByStatus')

const ExportInventory = () =>
  import(/* webpackChunkName: "Inventory" */ '@/components/inventory/modals/ExportInventory')

const dynamicModuleRegistrationInventoryArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'inventory',
    module: InventoryModule,
    store,
    modulePath: 'inventory'
  }
}

export default [
  {
    path: '/inventory',
    component: InventoryPlaceholder,
    name: InventoryEnum.InventoryPlaceholder,
    beforeEnter (_to, _from, next) {
      const waitFor = [
        DynamicModuleRegistrationUtil(dynamicModuleRegistrationInventoryArgs()),
        store.dispatch('fulfillmentCenter/getFulfillmentCenters', { loadingScopes: ['getInventory'] })
      ]
      Promise.all(waitFor).then(() => {
        InventoryRouteValidator.configureFulfillmentCenters(store.getters['fulfillmentCenter/fulfillmentCenters'].map(fc => fc.name))
        next()
      })
    },
    meta: { showSideNav: true, domain: InventoryEnum.Inventory },
    children: [
      {
        path: ':view',
        component: Inventory,
        name: InventoryEnum.Inventory,
        meta: { showSideNav: true },
        children: [
          {
            path: 'lot-breakdown/:inventoryId',
            component: LotBreakdown,
            name: InventoryEnum.LotBreakdown,
            props: (route) => ({
              inventoryId: parseInt(route.params.inventoryId)
            })
          },
          {
            path: 'lot-breakdown-by-status/:inventoryId',
            component: LotBreakdownByStatus,
            name: InventoryEnum.LotBreakdownByStatus,
            props: (route) => ({
              inventoryId: parseInt(route.params.inventoryId)
            })
          },
          {
            path: 'export-inventory',
            component: ExportInventory,
            name: InventoryEnum.ExportInventory,
            props: (route) => ({
              action: route.params.action === InventoryExportActions.onHand
                ? InventoryExportActions.onHand
                : InventoryExportActions.summary
            })
          }
        ]
      },
      {
        path: '/',
        component: Inventory,
        name: InventoryEnum.Inventory,
        meta: { showSideNav: true },
        beforeEnter (_to, _from, next) {
          next({ name: InventoryEnum.Inventory, params: { view: InventoryEnum.AllView } })
        }
      }
    ]
  }
]
